import React from "react";
import Slider from "react-slick";
import keyimg from "../../assets/images/K2S Key.png"
import {callAnalyticsAPI} from "../../api/user"
const device = getDevice();

function getDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) { return "windows"; }
    if (/android/i.test(userAgent)) { return "android"; }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) { return "ios"; }
    return undefined;
}


const fyponAreas = ['The Fypon Advantage','Explore Fypon','New Products']
class DisplayDataSelector extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            isClicked : '',
            refs :this.props.modalInfoObjSelected.ref
        }
    }

    componentDidMount() {
       


    }
    componentDidUpdate() {
       


    }

    changeContent = (val) => {

        var checkingArrayCollection = ["veris_collection","fiberglass_steel_entry_doors","veris_collection_pivot_door_systems",
        "veris_collection_hinged_door_systems","veris_collection_folding_door_systems","veris_collection_sliding_door_systems",
        "fiberglass_steel_entry_doors_glass_design","fiberglass_steel_entry_doors_glass_design_shaker",
        "fiberglass_steel_entry_doors_glass_prisma_guard",
        "fiberglass_steel_entry_doors_glass_advanta_lite","fiberglass_steel_entry_doors_glass_impression_storm",
        "fiberglass_steel_entry_doors_glass_prisma_guard"
        ]

        var visualiseRedirectAnalyticsSendList = ['veris_collection_pivot_door_systems_visualise'
        ,'veris_collection_hinged_door_systems_visualise','veris_collection_sliding_door_systems_visualise',
        'veris_collection_folding_door_systems_visualise']
        
        if(val.redirect) {

            if(visualiseRedirectAnalyticsSendList.includes(val.key)){

                const reqData = {}
                let user_id = sessionStorage.getItem("user_id");
                if (user_id) {
                    reqData.user_id = user_id;
                    reqData.area_id = "Trends & New Products";
                    reqData.resource_id = val.key;
                    reqData.resource_type = "redirect";
                    reqData.prev_area = 0;
                    reqData.spent_time = 0;
                    reqData.total_time = 0;
                    reqData.video_status = "";
                    reqData.download = 0;
                    reqData.guided_mode = 0;
                    callAnalyticsAPI(reqData)
                }
            }
          
            this.props.changevideoPlayStatus(true) 
      
            window.open(val.redirect, '_blank');   

            let visualiseitImageshows = ['veris_collection_pivot_door_systems_visualise','veris_collection_sliding_door_systems_visualise','veris_collection_folding_door_systems_visualise',
            'veris_collection_hinged_door_systems_visualise']
            if(!visualiseitImageshows.includes(val.key)){
                return;
            }
        }

   

        if(checkingArrayCollection.includes(val.key)) {
            this.props.changeModalContent(val.key)

        }

        if(this.props.navigationLevel === 3) {

            this.props.changeDisplayToButtonList()
        }

        if(this.props.navigationLevel === 0) {

            let poupinfoChildComponentUpdated = null
           this.props.modalContentInfo.forEach(element => {
                if(element.navigation_ref === val.key) {
                    poupinfoChildComponentUpdated = element
                }
            });



            this.props.setDisplayOnlyView(poupinfoChildComponentUpdated)

        }
    }



    handleClick = (e,val) => {

        document.querySelectorAll('.nav-link').forEach(ele => {
            ele.classList.remove('active')
        })


        e.target.classList.add('active')
        this.changeContent(val) 
        
    }

    handleSliderClick = (e,val) => {

        document.querySelectorAll('.slider_btn').forEach(ele => {
            ele.classList.remove('active')
        })


        e.target.parentNode.classList.add('active')
        this.changeContent(val) 

    }
    redirectToVeris = () => {

        this.props.changeModalContent("veris_collection")

    }

    render() {

        let that = this
                
        const settings = {
            dots: true,
            infinite: false,
            speed: 500,
            autoplay: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            initialSlide: 0,
            onInit : function() {

            },

            onReInit : function() {

             
            },
            responsive: [{
                breakpoint: 1500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            }, {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }]
        
        };
        let fyponclass= ""
        if(fyponAreas.includes(this.props.modalInfoObjSelected.area)){
            fyponclass = "fypon"
        }


        
        if(this.props.modalInfoObjSelected.ref === "fiberglass_full_advantage" || this.props.device !== undefined){

            let linkui =  null
            let linkText =  null

            if(this.props.selectorArray.length > 2) {


                linkui  = this.props.selectorArray.map((val , index) => {

                    let active = ""
                    if(index === 0) {
                        active = "active"
                    }


                    const name = val.name.split("<br>")

                    let breakName = ""
                    if(name.length > 0) {
                    
                        breakName = name[1]
                    }
          
                    if(val.slider){

                        return (<div>
                            <div className="image">
                                    <a className={`slider_btn ${active}`} href="#" onClick={(e) => {  this.handleSliderClick(e,val)   }}>
                                        {
                                            val.keyimg &&  <img src={keyimg} className="key-img" />
                                        }
                                    
                                       
                                    <span  >{name[0]} <br /> { breakName } </span></a>
                                </div> 
                            </div>
                            
                        )
                    }
      


                });

                linkText  = this.props.selectorArray.map((val , index) => {

                    let active = ""
                    if(index === 0) {
                        active = "active"
                    }

                    if(val.key === 'expert_register') {
                        return (<div>For live webinars Tuesday February 21, March 14 and <br/> April 11 from 1:00-3:30 PM EST</div>)
    
                    }
    
                    if(val.key === 'veris_system_information') {
                        return (<div className="veris_div">For Veris Collection door system information click <a href="#" className="nav-link-text" onClick={this.redirectToVeris}>here</a></div>)

                    }




                });

                return(
                    <>
                    <Slider {...settings} className="main_btns_div mt-2">
    
                    {linkui}
    
    
                    </Slider>
    
                    <div className="slider_bottom">
                     {linkText}
                    </div>
                    </>
        
                )
            }



        }

        let linkui =  null
        let overflowclass = ""
        if(this.props.selectorArray.length > 5) {
            overflowclass = "overflow_div"
        }

        if(this.props.selectorArray.length > 0) {


            linkui  = this.props.selectorArray.map((val , index) => {

                if(val.key === 'expert_register') {
                    return (<li className="nav-item text-center w-100 popup_footer" key={val.key}>
                                <a className="nav-link-text" id={val.key} data-toggle="tab" 
                                    href="#" role="tab" aria-controls="home" aria-selected="true"
                                    onClick={(e) => { 
                                        this.changeContent(val) 
                                        }}><span>{val.name}</span></a>
                                <p>For live webinars Tuesday February 21, March 14 and <br/> April 11 from 1:00-3:30 PM EST</p>
                        </li>)

                }

                if(val.key === 'veris_system_information') {
                    return (<li className="nav-item text-center w-100 popup_footer" key={val.key}>
                                 {
                                    val.keyimg &&  <img src={keyimg} className="key-img" />
                                }
                               
                                <p>{val.name}</p>
                        </li>)

                }

                let active = ""
                if(index === 0) {
                    active = "active"
                }
                let width_class = ""

                if(val.class) {

                    width_class  = val.class
                }


                const name = val.name.split("<br>")

                let breakName = ""
                if(name.length > 0) {

                    breakName = name[1]
                }

                return (<li className={`nav-item m-1 ${width_class}`} key={val.key} >
                        <a className={`nav-link ${ active }`}  id={val.key} data-toggle="tab" 
                            href="#" role="tab" aria-controls="home" aria-selected="true"
                            onClick={(e) => {  this.handleClick(e,val)   }}>
                                {
                                    val.keyimg &&  <img src={keyimg} className="key-img" />
                                }
                               
                                <span  >{name[0]} <br /> { breakName } </span></a>
                        </li>)




                } 
            )


        }

        


        return(

            
            linkui &&   <ul className={`nav nav-tabs ${fyponclass} ${overflowclass}`} id="myTab" role="tablist"> { linkui  } </ul>
           
        )
    }
}

export default DisplayDataSelector